import Vue from "vue";
import _ from "lodash";
import Vuex from "vuex";
import pathify from "@/store/pathify";
import VueRouter from "vue-router";
import Affix from "vue-affix";
import "@/lib/polyfills";
import "../../sass/vendor.scss";
import "../../sass/core.scss";

import PickPriceDrive from "@/components/PickPriceDrive";
import VueI18n from "vue-i18n";
import user from "@/store/modules/user";
import translated from "@/store/modules/translated";
import location from "@/store/modules/location";
import campaign from "@/store/modules/campaign";
import sessionReset from "@/store/modules/sessionReset";
import configure from "@/store/modules/configure";
import headerTransitionStore from "@/store/modules/headerTransitionStore";
import CarSaverPlugin from "@/lib/CarSaverPlugin";
import PowertrainPage from "Modules/Configure/Powertrain";
import ColorPage from "Modules/Configure/Color";
import OptionsPage from "Modules/Configure/Options";

Vue.use(Affix);

const environment = _.get(window, "appConfig.env[0]", "local") || "local";

Vue.use(Vuex);
Vue.use(VueI18n);

const debug = environment !== "production";

const store = new Vuex.Store({
    plugins: [pathify.plugin],

    modules: {
        user,
        translated,
        location,
        sessionReset,
        campaign,
        configure,
        headerTransitionStore
    },
    strict: debug
});

Vue.use(CarSaverPlugin);
Vue.use(VueRouter);

const defaultMessages = _.get(store, "state.translated.text", {});
const messages = {
    default: defaultMessages,
    en: {},
    es: {}
};
const i18n = new VueI18n({
    locale: "default",
    fallbackLocale: "default",
    messages
});

const routes = [
    {
        name: "powertrain",
        path: "/configure/style/:styleId",
        component: PowertrainPage,
        props: true
    },
    {
        name: "color",
        path: "/configure/style/:styleId/color",
        component: ColorPage,
        props: true
    },
    {
        name: "options",
        path: "/configure/style/:styleId/options",
        component: OptionsPage,
        props: true
    }
];

const router = new VueRouter({
    mode: "history",
    routes,
    scrollBehavior() {
        return { x: 0, y: 0 };
    }
});

if (document.getElementById("root") != null) {
    // eslint-disable-next-line no-new
    new Vue({
        el: "#root",

        store,

        router,

        i18n,

        components: {
            PickPriceDrive
        }
    });
}
